import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Navbar, NavLink } from "reactstrap";
import { ListGroup } from "reactstrap";
import { isEmpty } from "../../helpers/utils";
import { connect } from "react-redux";
import myConfig from "../../configs/config";

import { withRouter } from "react-router";
import { isMobileShellWidth } from "../../contexts/ShellMenuContext";

import {
  FaBars,
  FaAngleDown,
  FaEdit,
  FaUsers,
  FaUser,
  FaSignOutAlt,
  FaArrowLeft,
} from "react-icons/fa";

import "./Base.css";
import PlatformAccessCountdown from "./PlatformAccessCountdown";

function isOperationMachineView(pathname, farmId) {
  if (!farmId || !pathname) return false;
  const prefix = `/${farmId}/operation/`;
  if (!pathname.startsWith(prefix)) return false;
  const rest = pathname.slice(prefix.length);
  if (!rest) return false;
  const segment = rest.split("/")[0];
  if (!segment || segment === "add" || segment === "mult-operations") {
    return false;
  }
  return true;
}

class TopNavigation extends Component {
  state = {
    user: [],
    isOpen: true,
  };

  componentWillMount() {
    if (localStorage.getItem("client") !== null) {
      this.setState({ user: JSON.parse(localStorage.getItem("client")) });
    } else {
      // console.log(localStorage.getItem("client"));
      setTimeout(() => {
        this.setState({ user: JSON.parse(localStorage.getItem("client")) });
      }, 2000);
    }
  }

  handleLogout = () => {
    localStorage.clear();
    window.location.href = "/account/login/";
  };

  toggleDesktopSidebar = () => {
    const body = document.body;
    if (body.classList.contains("nav-md")) {
      body.classList.remove("nav-md");
      body.classList.add("nav-sm");
    } else {
      body.classList.remove("nav-sm");
      body.classList.add("nav-md");
    }
    this.setState({ isOpen: !this.state.isOpen });
  };

  toggleMenu = () => {
    if (isMobileShellWidth()) {
      if (this.props.onToggleMobileMenu) {
        this.props.onToggleMobileMenu();
      }
      return;
    }
    this.toggleDesktopSidebar();
  };

  render() {
    const { user } = this.state;
    const { farm_id, location, t, currentFarm, mobileMenuOpen } = this.props;
    const showOperationBack = isOperationMachineView(
      location && location.pathname,
      farm_id
    );
    let list_farms;

    if (!isEmpty(this.props.farms)) {
      list_farms = (
        <>
          {this.props.farms.map((farm) => (
            <li key={farm.id}>
              <a href={`${myConfig.ABSOLUTE_URL}${farm.id}/`}>
                <span>{farm.nome_da_fazenda.replace('"', "")}</span>
              </a>
            </li>
          ))}
        </>
      );
    }

    return (
      <>
        <div className="fixed top-navigation">
          <div className="top_nav">
            <div className="nav_menu">
              <Navbar>
                <div className="nav toggle">
                  <NavLink
                    id="menu_toggle"
                    href="#"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={
                      isMobileShellWidth()
                        ? mobileMenuOpen
                          ? t("Fechar menu")
                          : t("Abrir menu")
                        : t("Esconder/Mostrar menu")
                    }
                    aria-label={
                      isMobileShellWidth()
                        ? mobileMenuOpen
                          ? t("Fechar menu")
                          : t("Abrir menu")
                        : t("Esconder/Mostrar menu")
                    }
                    aria-expanded={
                      isMobileShellWidth() ? Boolean(mobileMenuOpen) : undefined
                    }
                    onClick={(event) => {
                      event.preventDefault();
                      this.toggleMenu();
                    }}
                  >
                    <FaBars />
                  </NavLink>
                </div>

                <ListGroup className="nav navbar-nav navbar-right">
                  {showOperationBack ? (
                    <li className="nav-item operation-nav-back">
                      <Link
                        to={`/${farm_id}/operation/`}
                        className="operation-nav-back-link"
                        title={t("Voltar para escolher outra máquina")}
                      >
                        <FaArrowLeft aria-hidden />
                        <span>{t("Trocar máquina")}</span>
                      </Link>
                    </li>
                  ) : null}
                  <PlatformAccessCountdown planAccess={currentFarm && currentFarm.plan_access} />
                  <li>
                    <NavLink
                      to="javascript:;"
                      className="user-profile dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {this.props.farm_name}
                      <span className="span"></span>
                      {/* <span className="fa fa-angle-down"> </span> */}
                      <FaAngleDown />
                    </NavLink>
                    <ListGroup className="list_farms dropdown-menu dropdown-usermenu pull-right">
                      <li>
                        <Link to={`/${this.props.farm_id}/change/`}>
                          <span className="span">
                            {/* <i className="fas fa-edit"></i> */}
                            <FaEdit />
                            {this.props.t("Editar")}
                          </span>
                        </Link>
                      </li>

                      {list_farms}

                      <li>
                        <Link to="/farms/">
                          <span className="span">
                            {/* <i className="fas fa-list"></i> */}
                            <FaUsers />
                            {this.props.t("Gerenciar Fazendas")}
                          </span>
                        </Link>
                      </li>
                    </ListGroup>
                  </li>

                  <li>
                    <NavLink
                      href="#"
                      className="user-profile dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img src={user.thumbnail} alt="thumbnail" />
                      {/* <span className=" fa fa-angle-down"></span> */}
                      <FaAngleDown />
                    </NavLink>
                    <ListGroup className="dropdown-menu dropdown-usermenu pull-right">
                      <li>
                        <Link to={`/account/update/${user.id}/`}>
                          <span className="span">
                            {/* <i className="fas fa-user"></i> */}
                            <FaUser />
                            {this.props.t("Perfil")}
                          </span>
                        </Link>
                      </li>

                      <li>
                        <Link to={`/${this.props.farm_id}/administrator/`}>
                          <span className="span">
                            {/* <i className="fas fa-users"></i> */}
                            <FaUsers />
                            {this.props.t("Administradores")}
                          </span>
                        </Link>
                      </li>

                      <li>
                        <a onClick={this.handleLogout}>
                          {/* <i className="fas fa-sign-out-alt"></i> */}
                          <FaSignOutAlt />
                          {this.props.t("Sair")}
                        </a>
                      </li>
                    </ListGroup>
                  </li>
                </ListGroup>
              </Navbar>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  farms: store.farm,
  currentFarm: store.current_farm,
});
export default withTranslation()(
  connect(mapStateToProps)(withRouter(TopNavigation))
);
